module.exports = __webpack_public_path__ + "img/logo.0ff97bb0.png";